module.exports = __webpack_public_path__ + "media/images/icon-question-b41e3fb3f871b4c0acd4b2b0a0aedf3b.svg";